import {ArrowRight} from './Icons';

/**
 * 服务条款 / 隐私政策。
 *
 * 正文仍是占位:旧站这两页一直是占位文本(src/components/LegalPlaceholder.tsx),
 * 新站接管同一域名后必须自己提供这两条路径,否则页脚链接会指回自己。
 * 正式法律文本到位后替换 body,不要把占位文字当成生效条款。
 */
export function LegalPage({kind}:{kind:'terms'|'privacy'}){
 const title=kind==='terms'?'服务条款':'隐私政策';
 return <section className="container legal-page">
  <span className="legal-kicker">{kind==='terms'?'TERMS':'PRIVACY'}</span>
  <h1>{title}</h1>
  <div className="legal-body">
   <p>正式内容待提供。</p>
   <p className="legal-note">本页面为占位内容，不构成任何法律文本；《{title}》正式版本发布前，请以官方公布的最终文本为准。</p>
   <p className="legal-note">对条款或个人信息处理有疑问，可以联系 <a href="mailto:support@isoplex.cn">support@isoplex.cn</a>。</p>
  </div>
  <a className="text-link" href="/">返回首页 <ArrowRight aria-hidden="true" size={15}/></a>
 </section>;
}
